import { useState } from 'react'
import { Button, Form, Table, Modal } from 'react-bootstrap'
import { FaPlus } from 'react-icons/fa6'

const AddFranchise = () => {

    const [show, setShow] = useState(false)

    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <h3>
                            Franchise
                        </h3>
                    </div>

                    <div className="col-auto">
                        <Button variant='primary' size='sm' onClick={handleShow}>
                            <FaPlus size={16} color='white' />
                        </Button>
                    </div>
                </div>

                <div className="col-12 mt-3">

                    <Table responsive bordered >
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Company Name</th>
                                <th>Company Owner</th>
                                <th>Shipping Office</th>
                                <th>PO Box</th>
                                <th>CNIC</th>
                                <th>Contact</th>
                                <th>Is Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>SR E Cart</td>
                                <td>Saqib</td>
                                <td>Nazimabad HPO</td>
                                <td>2110</td>
                                <td>03002458796</td>
                                <td>421014589652</td>
                                <td>
                                    <Form>
                                        <Form.Check // prettier-ignore
                                            type="switch"
                                            size="lg"
                                            id="custom-switch"
                                        // label="Check this switch"
                                        />
                                    </Form>
                                </td>
                            </tr>

                        </tbody>
                    </Table>

                </div>
            </div>




            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Franchise</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-2">
                            <Form.Label>Company Name</Form.Label>
                            <Form.Control type="text" placeholder="Enter name" />
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <Form.Label>Company Owner</Form.Label>
                            <Form.Control type="text" placeholder="Owner name" />
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="text" placeholder="Password" />
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>Shipping Office</Form.Label>
                            <Form.Control type="text" placeholder="Enter office" />
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>PO Box</Form.Label>
                            <Form.Control type="text" placeholder="Enter PO Box" />
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>CNIC</Form.Label>
                            <Form.Control type="text" placeholder="Enter CNIC" />
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>Contact</Form.Label>
                            <Form.Control type="text" placeholder="Enter contact" />
                        </Form.Group>


                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary">
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default AddFranchise